export enum ApiQueryName {
  AssistantInit = "initAssistant",
  AssistantThreads = "assistantThreads",
  Authentication = "authentication",
  AuthorizedOrganizations = "authorizedOrganizations",
  AvailableReportDates = "availableReportDates",
  BaCodes = "baCodes",
  Bill = "bill",
  BillPeriod = "billPeriod",
  BillPeriods = "billPeriods",
  BillPdfUploadSession = "billPdfUploadSession",
  BillPdfUploadSessionAnalysis = "billPdfUploadSessionAnalysis",
  Bills = "bills",
  BillsExport = "billsExport",
  BillDocument = "billDocument",
  BillLineItems = "billLineItems",
  BillingGroup = "billingGroup",
  BillingGroupCounts = "billingGroupCounts",
  BillingGroups = "billingGroups",
  BuildingTypes = "buildingTypes",
  CancelBillPdfUploadSession = "cancelBillPdfUploadSession",
  ComstockPredict = "comstockPredict",
  ConfirmBillPdfUploadSession = "confirmBillPdfUploadSession",
  CreateBillPdfUploadSession = "createBillPdfUploadSession",
  RemoveBillPdfUploadSessionRow = "removeBillPdfUploadSessionRow",
  UpdateBillPdfUploadSessionRow = "updateBillPdfUploadSessionRow",
  Currencies = "currencies",
  Credentials = "credentials",
  Data = "data",
  Department = "department",
  DepartmentCounts = "departmentCounts",
  Departments = "departments",
  DepartmentsSpraypaint = "departmentsSpraypaint",
  Disaggregation = "disaggregation",
  ElectricityCost = "electricityCost",
  EmissionProfile = "emissionProfile",
  EmissionProfiles = "emissionProfiles",
  EmissionsStats = "emissionsStats",
  EnergyAllocators = "energyAllocators",
  EnergyConsumption = "energyConsumption",
  EnergyStats = "energyStats",
  Flags = "flags",
  GresbReport = "gresbReport",
  GriReport = "griReport",
  Gtag = "gtag",
  Insights = "insights",
  IntervalHourlyUsageProfile = "intervalHourlyUsageProfile",
  IntervalRecordsExport = "intervalRecordsExport",
  Intervals = "intervals",
  IsSessionValid = "isSessionValid",
  Labs = "labs",
  Locales = "locales",
  Locations = "locations",
  LocationsV2 = "locationsV2",
  Meter = "meter",
  MeterCounts = "meterCounts",
  MeterSourceTypes = "meterSourceTypes",
  Meters = "meters",
  Organization = "organization",
  OrganizationCounts = "organizationCounts",
  OrganizationHierarchy = "organizationHierarchy",
  OrganizationSummaryStats = "organizationSummaryStats",
  OrganizationalUnit = "organizationalUnit",
  OrganizationalUnits = "organizationalUnits",
  Organizations = "organizations",
  PasswordUpdate = "passwordUpdate",
  PasswordUser = "passwordUser",
  Pendo = "pendo",
  PhysicalDetailTypes = "physicalDetailTypes",
  ResourceTypes = "resourceTypes",
  RetrofitMetadata = "retrofitMetadata",
  RetrofitProposalTemplates = "retrofitProposalTemplates",
  ScheduleMisalignment = "scheduleMisalignment",
  SetpointScenarios = "setpointScenarios",
  WeekProfile = "weekProfile",
  ScopeOneEmissions = "scopeOneEmissions",
  ScopeThreeEmissions = "scopeThreeEmissions",
  ScopeTwoEmissions = "scopeTwoEmissions",
  SigmaAccessToken = "sigmaAccessToken",
  SigmaRefreshAccessToken = "sigmaRefreshAccessToken",
  SigmaTeams = "sigmaTeams",
  SigmaWhoAmI = "sigmaWhoAmI",
  SigmaWorkbook = "sigmaWorkbook",
  SigmaWorkbookEmbedUrl = "sigmaWorkbookEmbedUrl",
  SigmaWorkbooks = "sigmaWorkbooks",
  Site = "site",
  SiteCounts = "siteCounts",
  SiteExplorer = "siteExplorer",
  SitePreviews = "sitePreviews",
  SiteUpdate = "siteUpdate",
  SiteVariance = "siteVariance",
  Sites = "sites",
  UpdateCredential = "updateCredential",
  UploadEmissions = "uploadEmissions",
  UploadEntities = "uploadEntities",
  UploadUsage = "uploadUsage",
  User = "user",
  UserCreate = "userCreate",
  Users = "users",
  UsCounties = "usCounties",
  UtilityCredentialSecret = "utilityCredentialSecret",
  ValidateAccount = "validateAccount",
}

export default {
  ApiQueryName,
}
